import Navbar from "../Containers/Navbar";
import { Center } from "@chakra-ui/react";

const Header = () => (
  <Center>
    <Navbar />
  </Center>
);

export default Header;
